import React from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
export default function useOutsideClick(
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  secondRef?: React.RefObject<HTMLElement>
) {
  function isOutsideBothRefObjects(event: MouseEvent) {
    return (
      ref.current &&
      !ref.current.contains(event.target as Node) &&
      secondRef?.current &&
      !secondRef.current.contains(event.target as Node)
    );
  }

  function isOutsideRefObject1Only(event: MouseEvent) {
    return (
      ref.current &&
      !ref.current.contains(event.target as Node) &&
      !secondRef?.current
    );
  }

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (isOutsideBothRefObjects(event) || isOutsideRefObject1Only(event)) {
        const timeOut = setTimeout(() => {
          callback();
          clearTimeout(timeOut);
        }, 10);
      }
    }

    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, secondRef, callback]);
}
